/**
 * Handing bytes the app already has to the browser as a file.
 *
 * The export routes answer with JSON rather than `text/csv` because this app
 * calls them with a bearer, so it cannot navigate to a URL and let the browser
 * save the response — the bytes come back through `fetch` either way and have
 * to become a Blob here.
 */
export function saveCsv(filename: string, csv: string): void {
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
